// extracted by mini-css-extract-plugin
module.exports = {"container":"get_channel_ad_container__WIruF","text":"get_channel_ad_text__7V6sz"};